import { getStore } from '~/mobx/AppStore';
import { showMessageModal } from '~/clientUtils/showMessageModal';
import electionApi from '~/clientApis/electionApi';

const getElections = async () => {
    const { companyStore, generalSettingsStore, electionMenuStore } = getStore();

    if (!companyStore.selectedSlagId) {
        return;
    }

    generalSettingsStore.setIsLoadingElectionList(true);

    try {
        const { isSettingsDisabled = false, selectedElectionId = '' } = generalSettingsStore;
        const result = await electionApi.getElectionList(companyStore.selectedSlagId, {
            electionId: selectedElectionId,
            isDisabled: isSettingsDisabled,
        });
        generalSettingsStore.fetchElectionData(result);
        electionMenuStore.setElection(result.election);
    } catch {
        showMessageModal('error', 'Failed to fetch elections');
    } finally {
        generalSettingsStore.setIsLoadingElectionList(false);
    }
};

export default getElections;
